module.exports = __webpack_public_path__ + "static/media/28DGC9.16c1985e.jpg";